import { render, staticRenderFns } from "./upLoadImg.vue?vue&type=template&id=504b043a&scoped=true&"
import script from "./upLoadImg.vue?vue&type=script&lang=js&"
export * from "./upLoadImg.vue?vue&type=script&lang=js&"
import style1 from "./upLoadImg.vue?vue&type=style&index=1&id=504b043a&prod&scoped=true&lang=scss&"
import style2 from "./upLoadImg.vue?vue&type=style&index=2&id=504b043a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504b043a",
  null
  
)

export default component.exports